module.exports = "<svg viewBox=\"0 0 10 10\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M4.08333 8.75V5.25H0.583333C0.261167 5.25 0 4.98883 0 4.66667C0 4.3445 0.261167 4.08333 0.583333 4.08333H4.08333V0.583333C4.08333 0.261167 4.3445 0 4.66667 0C4.98883 0 5.25 0.261167 5.25 0.583333V4.08333H8.75C9.07217 4.08333 9.33333 4.3445 9.33333 4.66667C9.33333 4.98883 9.07217 5.25 8.75 5.25H5.25V8.75C5.25 9.07217 4.98883 9.33333 4.66667 9.33333C4.3445 9.33333 4.08333 9.07217 4.08333 8.75Z\"/>\n</svg>\n";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./static/icons/buttons/plus.svg
// module id = FxTn
// module chunks = 0